module.exports = __webpack_public_path__ + "tk.svg?4487439056ff02dbe8e388c1139f5f2d";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/tk.svg
// module id = 1395
// module chunks = 27